import { useEffect, useState } from "react"
import { ReactComponent as ChevronIcon } from "../assets/images/icons/ic-chevron.svg"
import { Each } from "../common/Each"
import styles from "./Collapsable.module.css"
import Markdown from "react-markdown"

const Collapsable = ({ title = "", appearance="default", description, items, children, expanded = false, onExpand, headerStyle, style, active=true }) => {

    const [exp, setExp] = useState(expanded)

    useEffect(() => {
        setExp(expanded ?? false)
    }, [expanded])

    const toggleExpand = (e) => {
        e.stopPropagation()
        if (!exp && onExpand && typeof onExpand === 'function') {
            onExpand()
        }
        setExp(!exp)
    }

    return (
        <div className={`${styles.container} ${appearance==='transparent' ? styles.transparent : ''} ${appearance==='modern' ? styles.modern : ''} ${exp ? styles.expanded : ''}`}>
            <button type="button" aria-expanded={exp} className={`${styles.header} ${exp ? styles.expanded : ''}`} style={{...headerStyle, opacity: active ? 1 : (appearance === 'modern' ? .72 : .3)}} onClick={toggleExpand}>
                {title}
                <ChevronIcon className={`${styles.chevronIcon} ${exp ? styles.expanded : ''}`}></ChevronIcon>
            </button>
            {exp &&
                <div className={styles.divider}></div>
            }
            <div className={`${styles.content} ${exp ? styles.expanded : ''}`} style={style}>
                {items &&
                    <Each of={items} render={(item) => {
                        return (
                            <div className={`${styles.argument} ${exp ? styles.expanded : ''}`}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>•</div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    {item}
                                </div>
                            </div>
                        )
                    }} />
                }
                {!items && children}

                {description && <Markdown>{description}</Markdown>}
            </div>
        </div>
    )
}

export default Collapsable
